const LOGIN_PAGE = {
  title: 'Painel de administração',
  emailLabel: 'E-mail',
  passwordLabel: 'Senha',
  loginButton: 'Entrar',
  keepMeLoggedLabel: 'Mantenha-me conectado',
  forgotPassword: 'Esqueceu sua senha?',
  invalidEmailLabel: 'Este endereço de e-mail não é válido ...',
  accept: 'Aceitar',
  error: 'Erro',
  back: 'Voltar',
  registerNewPasswordTitle: 'Cadastre uma nova senha',
  registerNewPasswordText:
    'Para sua segurança, é necessário cadastrar uma nova senha de acesso a plataforma para o email',
  registerPassword: 'Cadastrar',
  newPasswordInputLabel: 'Nova senha',
  emailVerificationError:
    'Não foi possível enviar o e-mail de verificação de senha',
  emailVerificationLimitExceeded:
    'Limite de envios para e-mail de verificação de senha excedido',
  defaultChangePasswordError:
    'Não foi possível alterar a senha. Contate um administrador.',
  passwordChangedSuccessfully: 'Senha alterada com sucesso',
  continue: 'CONTINUAR',
  defaultRequestError: 'Houve um erro, tente novamente mais tarde',
  toHelpMessage:
    'Precisa de ajuda? Envie um email para parceiro_ze@ambev.com.br',
  passwordResetCognito: {
    title: 'Redefinição de senha',
    message:
      'Para garantir a segurança da sua conta, será necessário redefinir sua senha.',
    message2:
      'Para começar, vamos enviar um código de verificação para o email abaixo.',
    message3: 'Por onde quer receber o código de verificação?',
    inputLabel: 'email@pdv.com.br',
    toHelpMessage:
      'Precisa de ajuda? Envie um email para parceiro_ze@ambev.com.br',
    succesToast: 'O código foi enviado com sucesso!',
  },
  mfa: {
    mfaSelectionTitle: 'Verificação de segurança',
    mfaSelectionText:
      'Para garantir a segurança, vamos enviar um código de verificação para o email abaixo',
    verificationCodeTitle: 'Código de verificação',
    verificationCodeText: {
      email: 'Um código foi enviado para',
      message:
        ' Caso não tenha recebido, verifique se o e-mail está correto e a caixa de SPAM.',
    },
    resendCode: 'Reenviar código',
    resendCodeSuccess: 'Código reenviado',
    errors: {
      tryAgain: 'Tente novamente',
      resendCode: 'Clique em reenviar código e tente novamente',
      waitToTryAgain:
        'Você excedeu o limite de 10 tentativas, tente novamente em 15 minutos.',
      AUTH_0008: 'Código expirado',
      AUTH_0006: 'Código expirado',
      AUTH_0009: 'Código incorreto',
      AUTH_0013: 'Limite de reenvios do código excedido',
    },
  },
  phoneVerification: {
    title: 'Tudo certo, agora vamos cadastrar um número de celular',
    info: 'Para finalizar, vamos enviar um SMS para o número que cadastrar abaixo',
    verificationCodeText: {
      number: 'Um código foi enviado para',
      notice: 'Caso não tenha recebido, verifique se o número esta correto.',
    },
    verificationSuccess: 'Telefone cadastrado com sucesso',
  },
  loginOptions: {
    forgotPassword: 'Esqueci a senha',
    keepMeLogged: 'Manter conectado',
  },
  needHelp: {
    text: 'Precisa de ajuda? Envie um email para',
    email: 'parceiro_ze@ambev.com.br',
  },
  analytics: {
    componentCategory: {
      button: 'button',
      checkbox: 'checkbox',
      link: 'link',
    },
    componentName: {
      confirm: 'Confirmar',
      back: 'Voltar',
      resendCode: 'Reenviar código',
      keepMeLogged: 'Manter conectado',
    },
    modalName: {
      resendExceeded: 'Limite de reenvio excedido',
    },
    successType: {
      login: 'login',
    },
  },
}

export default LOGIN_PAGE
